// src/components/Layout/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="container">
        <p className="copyright-text">© {new Date().getFullYear()} DiscoverSupps.com. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
